<template>
  <div v-if="INVITATION_CODE" class="max-w-md lg:max-w-5xl mx-auto py-16">
    <div class="info-wrap">
      <div class="flex flex-col gap-y-2 text-left">
        <div class="flex items-center w-full text-sm pl-5">
          <h2 v-if="REWARD_BALANCE" class="text-left text-xl font-bold text-dark">
            {{ $t("profile.reward-balance-with-colon") }} ${{ REWARD_BALANCE }}
          </h2>
          <button class="ml-4 text-gray-600" @click="openRewardRecord">
            <font-awesome-icon :icon="['fa', 'history']" />
          </button>
        </div>
        <template v-if="enable">
          <div v-if="rebate" class="flex pl-5">
            <h2 class="text-left text-xl font-bold text-dark">
              {{ $t('profile.membership.level-with-colon') + level }}
            </h2>
            <div class="group relative ml-2">
              <font-awesome-icon :icon="['fa', 'info-circle']" class="text-sm align-middle" />
              <div
                class="bg-white shadow-md w-80 p-4 rounded-md group-hover:flex hidden absolute -bottom-2 translate-y-full left-1/2 -translate-x-1/2"
              >
                <i18n class="text-dark text-sm" path="profile.membership.earn-note" tag="span">
                  {{ toPercent(rebate) }}
                </i18n>
                <div
                  class="bg-inherit rotate-45 p-1 absolute top-0 -translate-y-1/2 left-1/2 -translate-x-1/2"
                ></div>
              </div>
            </div>
          </div>
          <template v-if="nextInfo">
            <h2 class="text-left text-xl font-bold text-dark pl-5">
              {{ $t('profile.membership.next.level-with-colon') + nextInfo.level }}
            </h2>
            <i18n v-if="nextInfo.requiredValue" class="text-left text-dark pl-5" path="profile.membership.next.upgrade-requires" tag="h2">
              ${{ nextInfo.requiredValue }}
            </i18n>
            <h2 class="text-left text-dark pl-5 pr-5" v-else>{{ $t('profile.membership.next.reach-max') }}</h2>
            <div class="rounded-full border-primary border w-full h-3.5 mt-2">
              <div class="rounded-full bg-primary h-3" :style="`width:${nextInfo.percent}%`"></div>
            </div>
          </template>
        </template>
        <hr class="mt-4" />
        <div class="flex items-baseline w-full text-sm mb-2 mt-4 pl-5">
          <h2 class="text-left text-xl font-bold text-dark">
            {{ $t("profile.invitation-code") }}
          </h2>
          <div v-if="showAvailableCount" class="ml-4 flex">
            <div class="group relative ml-2">
              <span class="font-semibold">{{ $t("profile.available") }} {{ AVAILABLE_COUNT }}</span>
              <div
                class="bg-white shadow-md w-80 p-4 rounded-md group-hover:flex hidden absolute -bottom-2 translate-y-full left-1/2 -translate-x-1/2"
              >
                <span class="text-dark text-sm">{{ $t('profile.code-limit-note') }}</span>
                <div
                  class="bg-inherit rotate-45 p-1 absolute top-0 -translate-y-1/2 left-1/2 -translate-x-1/2"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div
            class="mb-2 border-2 border-[#e6e6e6] h-[60px] rounded-xl w-full max-w-lg bg-white px-5 py-3 flex items-center lg:w-1/2"
            :class="{ '!border-primary': AVAILABLE_COUNT }"
          >
            <div
              class="font-bold text-2xl"
              :class="{ 'text-primary': AVAILABLE_COUNT }"
            >
              {{ INVITATION_CODE }}
            </div>
            <button
              v-if="AVAILABLE_COUNT"
              class="ml-auto"
              :class="{ '!text-primary': AVAILABLE_COUNT }"
              v-clipboard:copy="INVITATION_CODE"
              v-clipboard:success="onCopySuccess"
              v-clipboard:error="onCopyError"
              type="button"
            >
              <font-awesome-icon v-if="copied" :icon="['fas', 'check']" />
              <font-awesome-icon v-else :icon="['far', 'copy']" />
            </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUserMembership } from '@/utils/api/card'
import Big from 'big.js'
export default {
  data () {
    return {
      enable: false,
      level: null,
      rebate: '',
      nextInfo: null,
      copied: false
    }
  },
  computed: {
    ...mapGetters('CARD', [
      'INVITATION_CODE',
      'AVAILABLE_COUNT',
      'REWARD_BALANCE'
    ]),
    available () {
      return this.AVAILABLE_COUNT !== 0
    },
    showAvailableCount () {
      return this.AVAILABLE_COUNT !== -1 && this.AVAILABLE_COUNT <= 3
    }
  },
  mounted () {
    this.getInfo()
    // get invitation code
    this.$store.dispatch('CARD/GET_USER_INVITATION')
  },
  methods: {
    async getInfo () {
      try {
        const { enable, level, rebate, nextInfo } = await getUserMembership()
        this.enable = enable
        this.level = level
        this.rebate = rebate || ''
        this.nextInfo = nextInfo || null
      } catch (e) {
      }
    },
    toPercent (value) {
      try {
        return Big(value).times(100).toString()
      } catch (e) {
        return ''
      }
    },
    onCopySuccess () {
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2e3)
    },
    onCopyError () {
      alert('Failed to copy invitation code')
    },
    openRewardRecord () {
      this.$store.dispatch('MODAL/OPEN', 'RewardRecord')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-wrap {
  @apply bg-[#F4F4F4] rounded-2xl lg:rounded-[32px] py-[30px] px-5 lg:px-10;
  @apply justify-center items-center mb-2;
}
</style>
